import { StatelessComponent } from 'react'
import * as styles from 'styles/layouts/CardLayout.css'
import cn from 'classnames'
import { QAMarked } from 'interfaces/component'

type CardLayoutProps = QAMarked & {
  title?: string
  className?: string
}

const CardLayout: StatelessComponent<CardLayoutProps> = (props) => {
  const { children, title, className, qaMarker, qaType } = props

  const heading = title && (
    <h1 className={ styles.title }>
      { title }
    </h1>
  )

  return (
    <section className={ cn(styles.cardLayout, className) } data-qa-marker={ qaMarker } data-qa-type={ qaType }>
      { heading }
      { children }
    </section>
  )
}

export default CardLayout
